"use client";

import { ExclamationMark, CaretUpSolid, CaretDownSolid } from "@/icons";
import { Field, InputProps, Input } from "@headlessui/react";
import cn from "classnames";

const NumericInput = (
  props: InputProps & {
    invalidText?: string;
    formControlContainerClassName?: string;
  },
) => {
  const handleIncrement = () => {
    const input = document.querySelector(
      `input[name="${props.name}"]`,
    ) as HTMLInputElement;
    if (input) {
      input.stepUp();
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };

  const handleDecrement = () => {
    const input = document.querySelector(
      `input[name="${props.name}"]`,
    ) as HTMLInputElement;
    if (input) {
      input.stepDown();
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };

  return (
    <Field
      className="group relative flex w-full flex-col"
      disabled={props.disabled}
    >
      <div
        className={cn(
          "text-subhead-xl sm:text-headline-m md:text-headline-s text-body-secondary rounded-corner-subtle bg-swdc-cool-gray-100 border-swdc-silver-300 flex items-center border px-4 py-2 font-black",
          "group-focus-within:outline-swdc-blue-400 group-focus:outline-swdc-blue-400 group-active:outline-swdc-blue-400 group-focus-within:outline-2",
          props.formControlContainerClassName,
        )}
      >
        <Input
          {...props}
          className="w-full flex-1 bg-transparent outline-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
        <div className="ml-2 flex flex-col">
          <button
            type="button"
            onClick={handleIncrement}
            className="hover:enabled:bg-swdc-black/5 hover:enabled:rounded-full disabled:cursor-not-allowed"
            aria-label="Increment"
            disabled={Number(props.max) <= Number(props.value)}
          >
            <CaretUpSolid
              className="h-6 w-6"
              fill={
                Number(props.max) <= Number(props.value) ? "#a1a1a1" : "black"
              }
            />
          </button>
          <button
            type="button"
            onClick={handleDecrement}
            className="hover:enabled:bg-swdc-black/5 hover:enabled:rounded-full disabled:cursor-not-allowed"
            aria-label="Decrement"
            disabled={Number(props.min) >= Number(props.value)}
          >
            <CaretDownSolid
              className="h-6 w-6"
              fill={
                Number(props.min) >= Number(props.value) ? "#a1a1a1" : "black"
              }
            />
          </button>
        </div>
      </div>
      {"invalid" in props && Boolean(props.invalid) && (
        <div className="mt-3 flex items-center gap-x-2 pt-px">
          <ExclamationMark className="flex-none" aria-hidden />
          <span
            className="text-body-2xs text-swdc-red-500 text-left leading-none font-medium"
            id={`invalid-${props.name}`}
          >
            {props?.invalidText}
          </span>
        </div>
      )}
    </Field>
  );
};

export default NumericInput;
